import React from 'react';
import { MoreVertical, Import, FileDown, FileUp } from 'lucide-react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from 'src/shared/components/ui/dropdown-menu';

type SiteActionsMenuProps = {
    onImportFromProjects: () => void;
    onExportManifest: () => void;
    onImportManifest: () => void;
    projectCount: number;
};

const SiteActionsMenu = ({ onImportFromProjects, onExportManifest, onImportManifest, projectCount }: SiteActionsMenuProps) => {
    const importDisabled = projectCount === 0;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className='p-2 rounded-md hover:bg-grey-20 transition-colors'
                    data-testid='site-actions-trigger'
                    aria-label='Site actions'
                >
                    <MoreVertical className='w-5 h-5 text-grey-70' />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align='end'>
                <DropdownMenuItem
                    data-testid='action-import-projects'
                    disabled={importDisabled}
                    onSelect={e => {
                        if (importDisabled) {
                            e.preventDefault();
                            return;
                        }
                        onImportFromProjects();
                    }}
                    title={importDisabled ? 'No existing projects available to import' : undefined}
                >
                    <Import className='w-4 h-4' />
                    Import sites from existing projects
                </DropdownMenuItem>
                <DropdownMenuItem data-testid='action-export-manifest' onSelect={onExportManifest}>
                    <FileDown className='w-4 h-4' />
                    Export site manifest
                </DropdownMenuItem>
                <DropdownMenuItem data-testid='action-import-manifest' onSelect={onImportManifest}>
                    <FileUp className='w-4 h-4' />
                    Import site manifest
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default SiteActionsMenu;
